import styled from "styled-components";
import { SolutionColorVariables } from "@smartsuite/types";

export const StyledTabs = styled.div`
  height: 37px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledAutomationsTab = styled.div`
  margin-bottom: 26px;
  height: calc(100% - 180px);
  border-radius: 0 0 5px 5px;
  color: ${SolutionColorVariables.sc1};
`;

export const StyledAutomationCardList = styled.div`
  height: calc(100% - 39px);
  text-align: center;
  overflow: auto;
`;

export const EmptyBodyStyle = styled.div`
  height: 486px;
  padding: 40px 30px;
`;

export const StyledApplicationInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledApplicationCount = styled.div`
  margin-left: 8px;
`;

export const StyledAutomationsTabHeader = styled.div`
  display: inline-flex;
  align-items: center;

  margin: 0px 30px;

  cursor: pointer;
`;

export const EmptyContainer = styled.div`
  margin: 10px 30px 0px 30px;
`;

export const Footer = styled.div`
  border-top: 1px solid rgba(222, 222, 222, 0.7);
  padding: 10px 20px;

  .footer-action-button {
    width: 100%;
    justify-content: center;
  }
`;
